import { Component, Input, Output, EventEmitter } from '@angular/core';
import { AssetListStateService } from '../../services/asset-list-state.service';
import { FunnelHeaderService } from '../../services/funnel-header.service';
import { Asset } from '../../models/asset.model';

@Component({
  selector: 'mtm-funnel-header',
  templateUrl: './funnel-header.component.html',
  styleUrl: './funnel-header.component.scss',
  standalone: false,
})
export class FunnelHeaderComponent {
  @Input() funnel!: string;
  @Input() readOnly!: boolean;
  @Input() isProjectSetting!: boolean;
  @Input() isProjectDashboard!: boolean;
  @Input() bundle!: Asset[];
  @Input() originalBundle!: Asset[];
  @Input() projectId!: string;
  @Input() assetStar!: string;
  @Input() asWidget!: boolean;

  @Output() assetSelected: EventEmitter<any[]> = new EventEmitter<any[]>();
  @Output() addNewAssetEvent: EventEmitter<string> = new EventEmitter<string>();
  @Output() bulkUpdateAssets: EventEmitter<any> = new EventEmitter<any>();
  @Output() bundleChange: EventEmitter<{ newBundle: any[]; newOriginalBundle: any[] }> = new EventEmitter<{
    newBundle: Asset[];
    newOriginalBundle: Asset[];
  }>();
  @Output() updateTimelineAndProject: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    public readonly stateService: AssetListStateService,
    private readonly funnelHeaderService: FunnelHeaderService
  ) {}

  get isEditing(): boolean {
    return this.stateService.currentState.isEditing;
  }

  public getCheckboxImage(): string {
    return this.funnelHeaderService.getCheckboxImage(this.funnel, this.bundle);
  }

  public isAllassetSelected(): boolean {
    return this.funnelHeaderService.isAllassetSelected(this.funnel, this.bundle, this.projectId);
  }

  public isAllSelectedFromOther(): boolean {
    return this.funnelHeaderService.isAllSelectedFromOther(this.funnel, this.bundle, this.projectId);
  }

  public hasSelectedAssets(): boolean {
    return this.funnelHeaderService.hasSelectedAssets(this.funnel, this.bundle);
  }

  public areAllSelectedHidden(): boolean {
    return this.funnelHeaderService.areAllSelectedHidden(this.funnel, this.bundle);
  }

  public canDeleteAllSelected(): boolean {
    return this.funnelHeaderService.canDeleteAllSelected(this.funnel, this.bundle);
  }

  public toggleSelectAll(): void {
    this.funnelHeaderService.toggleSelectAll(this.funnel, this.bundle, (selectedAssetTypes: any) => {
      this.assetSelected.emit(selectedAssetTypes);
    });
  }

  public selecteAllasset(): void {
    this.funnelHeaderService.selecteAllasset(this.funnel, this.bundle, this.projectId);
  }

  public addNewAsset(): void {
    this.addNewAssetEvent.emit(this.funnel);
  }

  public toggleHideSelectedAssets(): void {
    const result: any = this.funnelHeaderService.toggleHideSelectedAssets(
      this.funnel,
      this.bundle,
      this.originalBundle,
      (data: { action: string; assetIds: string[] }) => this.bulkUpdateAssets.emit(data),
      (bundle: Asset[]) => this.bundleChange.emit({ newBundle: bundle, newOriginalBundle: this.originalBundle })
    );

    if (result) {
      this.bundleChange.emit(result);
    }
  }

  public duplicateSelectedAssets(): void {
    const result: { newBundle: Asset[]; newOriginalBundle: Asset[] } | null =
      this.funnelHeaderService.duplicateSelectedAssets(
        this.funnel,
        this.bundle,
        this.originalBundle,
        this.assetStar,
        this.projectId,
        this.asWidget,
        (data: { action: string; assetIds: string[] }) => this.bulkUpdateAssets.emit(data),
        (bundle: Asset[]) => this.bundleChange.emit({ newBundle: bundle, newOriginalBundle: this.originalBundle }),
        (data: any) => this.updateTimelineAndProject.emit(data)
      );

    if (result) {
      this.bundleChange.emit(result);
    }
  }

  public deleteSelectedAssets(): void {
    this.funnelHeaderService
      .deleteSelectedAssets(
        this.funnel,
        this.bundle,
        this.originalBundle,
        (data: { action: string; assetIds: string[] }) => this.bulkUpdateAssets.emit(data),
        (bundle: Asset[]) => this.bundleChange.emit({ newBundle: bundle, newOriginalBundle: this.originalBundle })
      )
      ?.then((result: { newBundle: Asset[]; newOriginalBundle: Asset[] } | null) => {
        if (result) {
          this.bundleChange.emit(result);
        }
      });
  }
}
